import './rendering.css';
import { useEffect, useState } from "react"
import {useLocation} from "react-router-dom";
import { jsPDF } from "jspdf";
import html2pdf from 'html2pdf.js';

const axios = require("axios").default;



function ColorLabelIdomyaPage() {
	const [isLoaded, setIsLoaded] = useState(false);
	const [colorLabelData, setColorLabelData] = useState(null);
	const search = useLocation().search;

	function PrintPdf() {
	    var listPageHtml = document.querySelectorAll('.pdfcontainerPortrait')
		listPageHtml.forEach((data, index) => {
			const productCode =colorLabelData.docIds[index].docId
			var options = {
				filename: productCode +"_colorLabelIdomya.pdf",
				html2canvas: {
					useCORS: true,
					scale: 300/96,
				},
				jsPDF: {
					format:"a3",
					unit:"mm"
				}
			}
			html2pdf(data,options);

			console.log("print")
    	})
	}

	useEffect(() => {

		const currentIds = new URLSearchParams(search).get('ids');
		const currentToken = new URLSearchParams(search).get('token');
		const currenLocale = new URLSearchParams(search).get('locale');
		//const today =  new Date().toLocaleString("fr-FR");
		document.title = "Color Label Idomya"

		axios.get("/api/colorLabel",{params: {token: encodeURIComponent(currentToken), ids:currentIds, locale: currenLocale, brand:"IDOMYA_F-"}}).then(resp => {
			if (resp.status == 200) {
				console.log("success",resp.data)
				setColorLabelData(resp.data)
				
			} else {
				console.log("error",resp.data)
			}
			setIsLoaded(true)
		}).catch(error => {
			console.log(error)
      		setIsLoaded(true)
		})

	}, [])

	let dataPdf;

	
	if (isLoaded) {
		if (colorLabelData != null) {
			let listStructData =  []

      

    		const dataLength =colorLabelData.docIds.length
			for (let index = 0; index < dataLength; index++) {
				const element = colorLabelData.docIds[index];
				let last = false;
				if (index == dataLength -1) {
					console.log("last")
					last = true;
				} 

				listStructData.push(<ColorLabelIdomyaTemplate data ={element} lastElement ={last}/> )
				
			}

			dataPdf = listStructData
		} else {
			dataPdf = <div className='pdfLoader'> Erreur dans la récupération des données</div>
		}
	} else {
		dataPdf =<div className='pdfLoader'>Récupération des données...<br/>Veuillez Patienter</div>
	}

	return (
		<div style={{margin: 0, display:"flex", flexDirection:"column"}}>
			<style>
		        {`@media print {
	    		    .pdfnextPage {
	            		page-break-after: always;
	          		}	
  
	        		.pdfbuttonContainerCL {
	            		display: none !important;
	          		}
  
	        		.pdfcontainerBorder {
	            		border-bottom: 0px solid black !important;
	          		}
  
	          		.pdfcontainerPortrait {
	            		top: 0px !important;
	          		}
  
	          		@page {
			            margin: 0;
	    		        size: A3 portrait;
	          		}
  
			        body {
			            -webkit-print-color-adjust: exact;
	    			    color-adjust: exact;
	          		}
          		}`}
		      </style>
			<div style={{position: "inherit"}} class="pdfbuttonContainerCL">
      			<button class="pdfprintPDFButton" onClick={PrintPdf}>
        			Print Idomya Color Label
      			</button>
    		</div>
			{dataPdf}
			
		</div>
		
	)
}

function ColorLabelIdomyaTemplate(props) {
	const sheetData = props.data
	const isLast = props.lastElement
	console.log(sheetData)

	const nomProduitLines = sheetData.declinaison_nom_reecrit.split("\n").map(line => <p style={styleSheetProductPage.titleText}> {line.toUpperCase()} </p>)

	const infoBonusLines = sheetData.infoBonus.split("\n").map(line => <p style={styleSheetProductPage.dataDimension}> {line} <br/> </p>)

	let lowerData = sheetData.infoUsine.toLowerCase()

	let splitDatas = lowerData.split('-')

    let capitalizedWords = splitDatas.map(word => {
        let trimmedWord = word.trimStart();
        if (trimmedWord.length > 0) {
            return word.slice(0, word.length - trimmedWord.length) + trimmedWord.charAt(0).toUpperCase() + trimmedWord.slice(1);
        } else {
            return word;
        }
    });

	let formatedData = capitalizedWords.join('-')

	useEffect(() => {
		console.log("parse data",isLast)
	},[])

	return (
		<div style={{ top:"0px", border:"0px", margin:"0", height:"420mm",width:"297mm"}} className={`pdfcontainerPortrait ${ isLast == true ? "" : "pdfnextPage" }`}>
			

			<div style={{  top: "0px", border: "0px", margin: "0", position : "absolute" }}>
				<img style={{ height: "420mm", width: "297mm" }} src={"/assets/images/fondColor/IDOMYA_FACTORY_OK.png"}/>
			</div>


			<div style={styleSheetProductPage.mainImgContainer}>
				<img style={{position: "absolute", top:"50%", left:"50%", transform:"translate(-50%, -50%)", "min-width":"100%", "height":"100%"}} src={sheetData.img1} />
			</div>
			{/* <div style={styleSheetProductPage.brandLogoContainer}>
				<img style={{width:"50mm"}}  src={sheetData.logobrand} />
			</div> */}
			<div style={styleSheetProductPage.titleContainer}>
				{nomProduitLines}
	        </div>
			
			<div style={styleSheetProductPage.img2Container}>
				<img style={{"border-top-right-radius": "20px", "border-bottom-right-radius": "20px","border-bottom-left-radius": "5px",position: "absolute", top:"50%", left:"50%", transform:"translate(-50%, -50%)", "min-width":"100%", "height":"100%"}} src={sheetData.imgMin} />
			</div>
			
			<div style={styleSheetProductPage.fakeShadow}>
				<img style={{width:"104mm", height:"12mm", "border-bottom-left-radius": "10px"}} src={"/assets/images/fondColor/BigShadow3.png"} />
			</div>

			<div style={styleSheetProductPage.plusProduitContainer}>
				<div style={styleSheetProductPage.plusProduitTextContainer}>
					<p style={styleSheetProductPage.plusProduitText}>{sheetData.infoPlus1}</p>
				</div>
				<div style={styleSheetProductPage.plusProduitTextContainer}>
					<p style={styleSheetProductPage.plusProduitText}>{sheetData.infoPlus2}</p>
				</div>
				<div style={styleSheetProductPage.plusProduitTextContainer}>
					<p style={styleSheetProductPage.plusProduitText}>{sheetData.infoPlus3}</p>
				</div>
				
				
				
			</div>

			<div style={styleSheetProductPage.dimensionContainer}>
				<p style={styleSheetProductPage.titleDimension}>Dimensions</p>
				<p style={styleSheetProductPage.dataDimension}>(L) {sheetData.infoLength} x (l) {sheetData.infoWidth} x (H) {sheetData.infoHeight} cm</p>
				{infoBonusLines}
			</div>

			{/* <div style={{width:"1.5mm", height:"28mm",position:"absolute",bottom:"35mm", left:"156mm", backgroundColor:"rgb(49,50,49)"}}>

			</div> */}

			<div style={styleSheetProductPage.materiauxContainer}>
				<p style={styleSheetProductPage.titleMateriaux}>Matériaux</p>
				<p style={styleSheetProductPage.dataMateriaux}>{sheetData.infoMateriaux} </p>
			</div>

			<div style={styleSheetProductPage.recyclageContainer}>
				<p style={styleSheetProductPage.refText}>Réf: {sheetData.docId} / Réf log: {sheetData.refColis}</p>	
			</div>

			<p style={styleSheetProductPage.wordingVertical}>{formatedData}</p>

			

		</div>
	)
}

const styleSheetProductPage = {
	pdfbackground:{
		position: "absolute",
	    height: "1223px",
    	"z-index": "-1",
	},
	mainImgContainer: {
    	position: "absolute",
	    top: "65mm",
    	left: "45mm",
	    display: "flex",
    	"flex-direction": "row",
	    "justify-content": "center",
	    "align-items": "center",
		"width":"228mm",
		"height":"228mm",
		overflow:"hidden"
  	},
 	brandLogoContainer: {
		position:"absolute",
		right:"35px",
		top:"25px"
  	},
	titleContainer: {
		position: "absolute",
	    left: "33mm",
    	top: "14mm",
		width:"198mm",
		height: "34mm",
	    display: "flex",
    	"justify-content": "center",
		"flex-direction":"column"
	},
	img2Container: {
		position:"absolute",
		// bottom:"26mm",
		top: "302mm",
		left:"54px",
		"border-top-right-radius": "20px",
		"border-bottom-right-radius": "20px",
		"z-index": "1",
		width:"102mm",
		height:"102mm",
		display:"flex",
		"align-items":"center",
		"justify-content":"center",
		"background-color":"white",
		"border-bottom-left-radius": "5px",
		overflow:"hidden"
		// "box-shadow": "-5px 15px 10px rgba(150, 150, 150, 0.5)"
		
	},
	fakeShadow: {
		position: "absolute",
		bottom:"8mm",
		left:"54px",
		"z-index": "0",
		// "border-bottom-left-radius": "20px",
	},
	plusProduitContainer:{
		position:"absolute",
		left:"126mm",
		bottom:"59.5mm",
		height: "55mm",
	    display: "flex",
    	"flex-direction": "column",
		"justify-content":"space-between",
    	"align-items": "baseline",
		width:"120mm",
	},
	plusProduitTextContainer: {
		height: "12mm",
		width: "120mm",
		display: "flex",
		"align-items": "center"
	},
	dimensionContainer:{
		position:"absolute",
		bottom:"27.5mm",
		right: "96mm",
		height: "21mm",
		width: "86mm",
		display: "flex",
		"flex-direction": "column",
		gap: "0.5rem",
	},
	materiauxContainer:{
		position:"absolute",
		left:"212mm",
		bottom:"27.5mm",
		height: "21mm",
		width: "86mm",
		display: "flex",
		"flex-direction": "column",
		gap: "0.5rem",
	},
	recyclageContainer: {
		position:"absolute",
		bottom: "4mm",
	    right: "10mm",
		height: "3mm",
		width: "128mm",
		display: "flex",
		"justify-content": "flex-end"
	},
	wordingVertical:{
		position:"absolute",
		transform: "rotate(-90deg)",
		"transform-origin": "left",
	    bottom: "25mm",
	    left: "6mm",
	    color: "white",
		"font-family":"Helvetica-Neue",
		"font-size": "9pt",
		"font-weight": "regular",
	    "line-height": "9pt",
		height: "3mm",
		width: "240mm"
		
	},
	plusProduitText: {
		color:"white",
		"font-family":"Helvetica-Neue",
		"font-size": "18pt",
		"font-weight": "900",
	    "line-height": "20pt"
	},
	refText: {
		"font-family":"Helvetica-Neue",
		"font-size": "10pt",
		"font-weight": "regular",
	    "line-height": "10pt",
		"margin-left":"28px",
		"margin-bottom":"2mm"
	},
	titleText:{
		"font-family":"Lucida-Grande",
		"font-size": "31pt",
	    "line-height": "34pt",
		"font-weight": "900"
	},
	titleMateriaux: {
		"font-family":"Helvetica-Neue",
		"font-size": "18pt",
	    "line-height": "20pt",
		"font-weight": "900"
	},
	dataMateriaux: {
		"font-family":"Helvetica-Neue",
		"font-size": "15pt",
	    "line-height": "15pt",
		"max-width":"485px",
		"font-weight": "regular"
	},
	titleDimension: {
		"font-family":"Helvetica-Neue",
		"font-size": "18pt",
	    "line-height": "20pt",
		"font-weight": "900",
		"text-align": "right"
	},
	dataDimension: {
		"font-family":"Helvetica-Neue",
		"font-size": "15pt",
	    "line-height": "15pt",
		"text-align":"right",
		"font-weight": "regular"
	},
	pictoRecyclage:{
		height:"19.56mm",
		width:"60mm"
	}



	
}

export default ColorLabelIdomyaPage